import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { get as _get } from "lodash";

import CampaignSetupProgress from "../CampaignSetupProgress";

import { resetCampaignSetupError, updateCampaignSetupDetails } from "../../../../redux/actions/campaignSetup";
import { updateLoadingState } from "../../../../redux/actions/application";
import UploadCustomFields from "./UploadCustomFields";

class CustomFields extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isEditMode: false,
      callCustomFieldSubmitAPI: false,
    };
  }

  componentDidMount() {
    const { summary: { common: { lastFilledStep } }, currentStep } = this.props;

    //Set default or existing values
    this.setState({
      isEditMode: (lastFilledStep > currentStep) ? true : false
    });
  }

  handleNext = (savedCustomFields = []) => {
    const { summary: { common }, summary: { common: { lastFilledStep } }, currentStep, updateCampaignSetupDetails, intl } = this.props;

    const finalUploadedCustomFields = (savedCustomFields || []).filter(item => item.field_name.trim() !== "");

    if ((typeof updateCampaignSetupDetails === "function")) {
      const variable = {
        "common": {
          ...common,
          currentStep: (currentStep + 1),
          lastFilledStep: (lastFilledStep > currentStep) ? lastFilledStep : (currentStep + 1),
        },
        [currentStep]: {
          summaryText: intl.formatMessage({ id: "campaign_setup.custom_fields.title", defaultMessage: "Custom Fields" }),
          allUploadedCustomFields: (finalUploadedCustomFields || []),
        }
      }

      updateCampaignSetupDetails(variable);
    }
  }

  render() {
    const { currentStep, totalSteps, onPreviousStep, campaignId, clientId } = this.props;
    const { callCustomFieldSubmitAPI } = this.state;

    return (
      <div className="row">
        <div className="col-lg-8">
          <div className="card">
            <div className="card-body py-5 vh-165">
              <h6 className="heading-04 fw-semibold mb-6">{`Step ${currentStep} of ${totalSteps} - Custom Fields`}</h6>

              <UploadCustomFields
                source="campaign_setup"
                campaignId={(campaignId || null)}
                clientId={(clientId || null)}
                goToNext={(savedCustomFields) => this.handleNext(savedCustomFields)}
                callCustomFieldSubmitAPI={(callCustomFieldSubmitAPI || false)}
              />

              <div className="row mt-auto">
                <div className="col-lg-12">
                  <div className="d-flex align-items-center justify-content-between gap-4 mt-4">
                    <button className="btn btn-primary text-capitalize" onClick={() => { if (typeof onPreviousStep === "function") { onPreviousStep() } }}>
                      <FormattedMessage id="btn.back" defaultMessage="back" />
                    </button>
                    <button className="btn btn-primary text-capitalize" onClick={() => this.setState({ callCustomFieldSubmitAPI: true })}>
                      <FormattedMessage id="btn.next" defaultMessage="next" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <CampaignSetupProgress />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  summary: _get(state, "campaignSetup.summary", {}),
  clientId: _get(state, "campaignSetup.summary.common.clientId", null),
  campaignId: _get(state, "campaignSetup.summary.common.campaignId", null),
  currentStep: _get(state, "campaignSetup.summary.common.currentStep", 1),
  allowedCustomFieldsFiles: _get(state, "application.constants.allowedCustomFieldsFiles", ""),
  allowedCustomFieldsFilesLabel: _get(state, "application.constants.allowedCustomFieldsFilesLabel", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
  resetCampaignSetupError: () => dispatch(resetCampaignSetupError()),
  updateCampaignSetupDetails: (data) => dispatch(updateCampaignSetupDetails(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CustomFields));
